import React, { useContext } from 'react';

import PageHeader from '@/components/PageHeader';
import { useSubstanceTrackerSummary } from '@/hooks/useSubstanceTracker';
import PersonContext from '@/pages/Person/PersonContext';
import Container from '@/ui/components/Container';
import LoadingSkeleton from '@/ui/components/LoadingSkeleton';

import SubstanceTrackerLogs from './components/SubstanceTrackerLogs';
import SubstanceTrackerMetrics from './components/SubstanceTrackerMetrics';

const SubstanceTracker = () => {
  const { person } = useContext(PersonContext);
  const { data: summaryResponse, isPending } = useSubstanceTrackerSummary(person.id);
  return (
    <Container type="page">
      <PageHeader headingText="Substance Tracker" className="sr-only" />
      {isPending ? (
        <LoadingSkeleton spinnerProps={{ label: 'Loading Substance tracker' }} />
      ) : (
        <>
          {summaryResponse?.data?.results === undefined ? (
            <div className="flex-1 flex items-center justify-center">
              <span className="ext-red-500">No substance tracker has been set up yet.</span>
            </div>
          ) : (
            summaryResponse?.data?.results.map((result, index) => (
              <React.Fragment key={`${index}-container`}>
                <SubstanceTrackerMetrics key={`${index}-metrics`} result={result} index={index} />
                <SubstanceTrackerLogs logs={result.last_logs} index={index} />
              </React.Fragment>
            ))
          )}
        </>
      )}
    </Container>
  );
};

export default SubstanceTracker;
